<template>
  <button
    v-if="visible && itemUuid"
    type="button"
    class="rms-public-owner-edit-fab"
    :class="tone === 'dark' ? 'rms-public-owner-edit-fab--dark' : 'rms-public-owner-edit-fab--light'"
    :aria-label="$t('public.ownerEditMenuItemInCatalogAria')"
    @click.stop.prevent="goEdit"
  >
    <span class="material-symbols-outlined rms-public-owner-edit-fab__icon" aria-hidden="true">edit</span>
  </button>
</template>

<script setup>
import { useRouter } from 'vue-router'

const props = defineProps({
  itemUuid: { type: String, default: '' },
  visible: { type: Boolean, default: false },
  /** Use dark style on dark menu backgrounds (e.g. template 3). */
  tone: { type: String, default: 'light', validator: (v) => ['light', 'dark'].includes(v) },
})

const router = useRouter()

function goEdit() {
  if (!props.itemUuid) return
  router.push({ name: 'MenuItemEdit', params: { itemUuid: props.itemUuid } })
}
</script>

<style scoped>
.rms-public-owner-edit-fab {
  position: absolute;
  right: 0rem;
  bottom: 0;
  z-index: 20;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem;
  height: 2.75rem;
  min-width: 2.75rem;
  min-height: 2.75rem;
  padding: 0;
  border-radius: 9999px;
  border-width: 1px;
  border-style: solid;
  cursor: pointer;
  box-shadow: 0 4px 14px rgb(15 23 42 / 0.12);
  transition: background-color 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease;
}
.rms-public-owner-edit-fab:hover {
  transform: scale(1.04);
  box-shadow: 0 6px 18px rgb(15 23 42 / 0.16);
}
.rms-public-owner-edit-fab:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}
.rms-public-owner-edit-fab--light {
  background-color: #fff;
  border-color: rgb(226 232 240);
  color: rgb(51 65 85);
}
.rms-public-owner-edit-fab--light:hover {
  background-color: rgb(248 250 252);
}
.rms-public-owner-edit-fab--dark {
  background-color: rgb(30 41 59 / 0.92);
  border-color: rgb(255 255 255 / 0.18);
  color: rgb(241 245 249);
}
.rms-public-owner-edit-fab--dark:hover {
  background-color: rgb(51 65 85 / 0.95);
}
.rms-public-owner-edit-fab--dark:focus-visible {
  outline-color: rgb(96 165 250);
}
.rms-public-owner-edit-fab__icon {
  font-size: 1rem;
  line-height: 1;
}
</style>
